<template>
  <div class="consult-container">
    <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>

    <div class="search-container">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="咨询时间">
          <el-date-picker
            v-model="formInline.askDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-loading="tableLoading" class="table-container">
      <el-table :data="tableData" :pagination="pagination" border style="width: 100%">
        <el-table-column prop="askName" label="咨询人称呼" align="center">
        </el-table-column>
        <el-table-column
          prop="askDate"
          label="咨询时间"
          align="center"
          :formatter="dateFormat"
        >
        </el-table-column>
        <el-table-column prop="phone" align="center" label="联系方式"> </el-table-column>
        <el-table-column prop="content" align="center" label="咨询描述">
        </el-table-column>
        <el-table-column prop="recordStatus" align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.recordStatus === 0">未回复</span>
            <span v-else-if="scope.row.recordStatus === 1">已回复</span>
            <span v-else>未知状态</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看</el-button
            >
            <el-button type="text" size="small" @click="handleReplyClick(scope.row)"
              >回复</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 回复功能 -->
    <el-drawer
      title="回复"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="drawerForm" label-width="80px">
        <el-form-item label="回复内容">
          <el-input
            type="textarea"
            rows="6"
            v-model="drawerForm.recordContent"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="submitReply" :loading="loading">{{
          loading ? "提交中 ..." : "确 定"
        }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getConsultList, getConsultReply } from "@/api/portalManagement";
import moment from "moment";
import ComDetail from "@/components/common/comDetail.vue";
export default {
  name: "AdminStaticsConsult",
  components: {
    ComDetail,
  },
  data() {
    return {
      tableLoading: false,
      detail: {
        visible: false,
        record: {},
      },
      detailCols: [
        {
          label: "咨询人称呼",
          prop: "askName",
        },
        {
          label: "申请时间",
          prop: "askDate",
          formatter: (row) => moment(row.askDate).format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          label: "联系方式",
          prop: "phone",
        },
        {
          label: "咨询描述",
          prop: "content",
        },
      ],
      drawer: false,
      formInline: {
        askDate: "",
      },
      pagination: {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: "total, prev, pager, next, jumper", // 分页布局
      },
      tableData: [],
      drawerForm: {
        recordContent: "",
      },
      record: {},
    };
  },

  mounted() {
    this.loadData();
  },
  methods: {
    // 查看
    onCancel() {
      this.detail.visible = false;
    },
    cancelForm() {
      this.drawer = false;
    },
    submitReply() {
      getConsultReply({
        recordContent: this.drawerForm.recordContent,
        id: this.record.id,
      }).then(() => {
        this.$message.success("回复成功");
        this.drawer = false;
        this.loadData();
      });
    },
    // 时间转换
    dateFormat(row) {
      return moment(row.askDate).format("YYYY-MM-DD HH:mm:ss");
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.loadData();
    },
    handleClick(row) {
      this.detail.visible = true;
      this.detail.record = row;
    },
    handleReplyClick(row) {
      this.drawer = true;
      this.record = row;
    },
    onSubmit() {
      this.loadData();
    },
    async loadData() {
      this.tableLoading = true;
      const params = {};
      if (this.formInline.askDate) {
        params.startTime = moment(this.formInline.askDate[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        params.endTime = moment(this.formInline.askDate[1]).format("YYYY-MM-DD 23:59:59");
      }
      await getConsultList({
        askType: 0,
        pageNo: this.pagination.currentPage - 1,
        pageSize: this.pagination.pageSize,
        ...params,
      }).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data.content;
        this.pagination.total = res.data.totalElements;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.consult-container {
  background: #fff;
  padding: 24px 0;

  .search-container {
    padding: 0 16px;
    border-bottom: 1px solid #ebeef5;
  }

  .table-container {
    padding: 16px;
  }

  .pagination-container {
    margin-top: 16px;
    text-align: right;
  }

  .drawer-footer {
    text-align: center;
  }
}

::v-deep .el-drawer__body {
  padding: 0 16px;
}
</style>
